import { http } from '../../http/http';

export default (entityRef, token) => {
  return Promise.resolve({
    valid: true,
    userRef: '02baffa1-f46f-4073-89f4-4fa1df033c27',
  });
  // http.post({ apiName: 'authnz', path: `/users/${entityRef}/verify-token`, data: { token } });
};
